export const siteInfo = {
  name: '91com官方平台',
  tagline: '91com最新入口与使用指南',
  description: '91com是广受用户关注的热门平台，本页为您详细介绍91com的官方入口、核心功能、使用方法及常见问题解答，助您快速找到91com并安全使用，获取最佳体验。',
  url: 'https://91com.com',
  email: 'contact@91com.com',
  phone: '400-888-9191',
  address: '北京市朝阳区建国路88号SOHO现代城',
  founded: '2018',
  usersCount: '500万+',
  rating: '4.8',
  reviewsCount: '12,000+',
};